import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

import style from './index.module.scss';

@Component({ name: 'DebtSituation' })
export default class DebtSituation extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private debtSituation: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.debtSituation = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.debtSituation) {
      this.debtSituation = val;
    }
  }

  public onValidator(): boolean {
    if (this.debtSituation === undefined || this.debtSituation === null) {
      this.errorMsg = '请选择已有负债';
      return false;
    }

    return true;
  }

  private onChangeDebtSituation(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.DebtSituation}>
        <Field
          v-model={this.debtSituation}
          onChange={() => this.onChangeDebtSituation(this.debtSituation)}
          sub={true}
          label="已有负债"
          type="select"
          dictApi={DictApi.getDebtSituation}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
